import vue from "vue";

const state = {
  update: false,
  hasChanges: false,
  discardChanges: false,
  isAllFieldsFilled: false,
  saveHandler: false,
  isLoading: false
};

const mutations = {
  SET_PROPOSAL_UPDATE(state, val) {
    vue.set(state, "update", val);
  },
  SET_PROPOSAL_HAS_CHANGES(state, val) {
    vue.set(state, "hasChanges", val);
  },
  SET_PROPOSAL_DISCARD_CHANGES(state, val) {
    vue.set(state, "discardChanges", val);
  },
  SET_PROPOSAL_IS_ALL_FIELDS_FILED(state, val) {
    vue.set(state, "isAllFieldsFilled", val);
  },
  SET_PROPOSAL_ACCEPT_PROPOSAL(state, val) {
    vue.set(state, "saveHandler", val);
  },
  SET_PROPOSAL_IS_LOADING(state, val) {
    vue.set(state, "isLoading", val);
  }
};

export default {
  state,
  mutations
};
